<template>
  <div style="background-color:#425C80;background-image: url('/images/PrayerRequest.png'); background-size:cover; background-position:center;">
    <div class="pt-10">
      <v-container>
        <div
          style="text-align:center;"
        >
          <h1 class="text-h3" style="color:#ffffff90;">Prayer Request</h1>
        </div>
        <PrayerRequestForm />
      </v-container>
    </div>
  </div>
</template>

<script>
import PrayerRequestForm from '@/components/PrayerRequestForm.vue'
export default {
  name: 'PrayerRequest',
  components: {
    PrayerRequestForm
  }
}
</script>

<style>
  a {
    text-decoration: none;
  }
</style>
